import { FunctionComponent } from 'react';
import { Beta } from '../Beta/Beta';
import { VersionNumber } from '../VersionNumber/VersionNumber';

export const SidebarHeader: FunctionComponent = () => {
  return (
    <div className="h-stack items-center space-x-2">
      <div className="w-16 h-16">
        <img src="/images/icons/moon_shiny_red.svg" />
      </div>
      <div className="v-stack items-center space-y-1">
        <Beta />
        <VersionNumber />
      </div>
    </div>
  );
};
